module.exports = __webpack_public_path__ + "img/account-grey56.015ed7df.svg";